//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.BooleanAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.NullableBooleanAdapter
import com.apollographql.apollo.api.NullableIntAdapter
import com.apollographql.apollo.api.NullableStringAdapter
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.InspectionByIdWithMediaUrlQuery
import com.wintermar.inspection.graphql.type.FindingCategory
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import com.wintermar.inspection.graphql.type.InspectionStatus
import com.wintermar.inspection.graphql.type.adapter.FindingCategory_ResponseAdapter
import com.wintermar.inspection.graphql.type.adapter.InspectionAnswerType_ResponseAdapter
import com.wintermar.inspection.graphql.type.adapter.InspectionStatus_ResponseAdapter
import kotlin.Any
import kotlin.Boolean
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public object InspectionByIdWithMediaUrlQuery_ResponseAdapter {
  public object Data : Adapter<InspectionByIdWithMediaUrlQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("inspectionByIdWithMediaUrl")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Data {
      var _inspectionByIdWithMediaUrl: InspectionByIdWithMediaUrlQuery.InspectionByIdWithMediaUrl? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _inspectionByIdWithMediaUrl = InspectionByIdWithMediaUrl.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Data(
        inspectionByIdWithMediaUrl = _inspectionByIdWithMediaUrl ?: missingField(reader, "inspectionByIdWithMediaUrl")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Data,
    ) {
      writer.name("inspectionByIdWithMediaUrl")
      InspectionByIdWithMediaUrl.obj().toJson(writer, customScalarAdapters, value.inspectionByIdWithMediaUrl)
    }
  }

  public object InspectionByIdWithMediaUrl : Adapter<InspectionByIdWithMediaUrlQuery.InspectionByIdWithMediaUrl> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "status", "lastUpdatedAt", "templateId", "conductedAt", "template")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.InspectionByIdWithMediaUrl {
      var _id: Any? = null
      var _status: InspectionStatus? = null
      var _lastUpdatedAt: Any? = null
      var _templateId: Any? = null
      var _conductedAt: Any? = null
      var _template: InspectionByIdWithMediaUrlQuery.Template? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _status = InspectionStatus_ResponseAdapter.fromJson(reader, customScalarAdapters)
          2 -> _lastUpdatedAt = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          3 -> _templateId = AnyAdapter.fromJson(reader, customScalarAdapters)
          4 -> _conductedAt = AnyAdapter.fromJson(reader, customScalarAdapters)
          5 -> _template = Template.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.InspectionByIdWithMediaUrl(
        id = _id ?: missingField(reader, "id"),
        status = _status ?: missingField(reader, "status"),
        lastUpdatedAt = _lastUpdatedAt,
        templateId = _templateId ?: missingField(reader, "templateId"),
        conductedAt = _conductedAt ?: missingField(reader, "conductedAt"),
        template = _template ?: missingField(reader, "template")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.InspectionByIdWithMediaUrl,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("status")
      InspectionStatus_ResponseAdapter.toJson(writer, customScalarAdapters, value.status)

      writer.name("lastUpdatedAt")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.lastUpdatedAt)

      writer.name("templateId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.templateId)

      writer.name("conductedAt")
      AnyAdapter.toJson(writer, customScalarAdapters, value.conductedAt)

      writer.name("template")
      Template.obj().toJson(writer, customScalarAdapters, value.template)
    }
  }

  public object Template : Adapter<InspectionByIdWithMediaUrlQuery.Template> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "name", "version", "publishedDate", "parentId", "numberOfPages", "numberOfSections", "numberOfQuestions", "pages")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Template {
      var _id: Any? = null
      var _name: String? = null
      var _version: Int? = null
      var _publishedDate: Any? = null
      var _parentId: Any? = null
      var _numberOfPages: Int? = null
      var _numberOfSections: Int? = null
      var _numberOfQuestions: Int? = null
      var _pages: List<InspectionByIdWithMediaUrlQuery.Page>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _name = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _version = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _publishedDate = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          4 -> _parentId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          5 -> _numberOfPages = NullableIntAdapter.fromJson(reader, customScalarAdapters)
          6 -> _numberOfSections = NullableIntAdapter.fromJson(reader, customScalarAdapters)
          7 -> _numberOfQuestions = NullableIntAdapter.fromJson(reader, customScalarAdapters)
          8 -> _pages = Page.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Template(
        id = _id ?: missingField(reader, "id"),
        name = _name ?: missingField(reader, "name"),
        version = _version ?: missingField(reader, "version"),
        publishedDate = _publishedDate,
        parentId = _parentId,
        numberOfPages = _numberOfPages,
        numberOfSections = _numberOfSections,
        numberOfQuestions = _numberOfQuestions,
        pages = _pages ?: missingField(reader, "pages")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Template,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("name")
      StringAdapter.toJson(writer, customScalarAdapters, value.name)

      writer.name("version")
      IntAdapter.toJson(writer, customScalarAdapters, value.version)

      writer.name("publishedDate")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.publishedDate)

      writer.name("parentId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.parentId)

      writer.name("numberOfPages")
      NullableIntAdapter.toJson(writer, customScalarAdapters, value.numberOfPages)

      writer.name("numberOfSections")
      NullableIntAdapter.toJson(writer, customScalarAdapters, value.numberOfSections)

      writer.name("numberOfQuestions")
      NullableIntAdapter.toJson(writer, customScalarAdapters, value.numberOfQuestions)

      writer.name("pages")
      Page.obj().list().toJson(writer, customScalarAdapters, value.pages)
    }
  }

  public object Page : Adapter<InspectionByIdWithMediaUrlQuery.Page> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "templateId", "order", "title", "sections")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Page {
      var _id: Any? = null
      var _templateId: Any? = null
      var _order: Int? = null
      var _title: String? = null
      var _sections: List<InspectionByIdWithMediaUrlQuery.Section>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _templateId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _title = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _sections = Section.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Page(
        id = _id ?: missingField(reader, "id"),
        templateId = _templateId ?: missingField(reader, "templateId"),
        order = _order ?: missingField(reader, "order"),
        title = _title ?: missingField(reader, "title"),
        sections = _sections ?: missingField(reader, "sections")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Page,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("templateId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.templateId)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("title")
      StringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("sections")
      Section.obj().list().toJson(writer, customScalarAdapters, value.sections)
    }
  }

  public object Section : Adapter<InspectionByIdWithMediaUrlQuery.Section> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "pageId", "order", "title", "questions")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Section {
      var _id: Any? = null
      var _pageId: Any? = null
      var _order: Int? = null
      var _title: String? = null
      var _questions: List<InspectionByIdWithMediaUrlQuery.Question>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _pageId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          3 -> _title = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _questions = Question.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Section(
        id = _id ?: missingField(reader, "id"),
        pageId = _pageId ?: missingField(reader, "pageId"),
        order = _order ?: missingField(reader, "order"),
        title = _title ?: missingField(reader, "title"),
        questions = _questions ?: missingField(reader, "questions")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Section,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("pageId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.pageId)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("title")
      StringAdapter.toJson(writer, customScalarAdapters, value.title)

      writer.name("questions")
      Question.obj().list().toJson(writer, customScalarAdapters, value.questions)
    }
  }

  public object Question : Adapter<InspectionByIdWithMediaUrlQuery.Question> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "sectionId", "questionText", "guidelines", "required", "order", "answerType", "failedOptionId", "neutralOptionId", "answers")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Question {
      var _id: Any? = null
      var _sectionId: Any? = null
      var _questionText: String? = null
      var _guidelines: String? = null
      var _required: Boolean? = null
      var _order: Int? = null
      var _answerType: InspectionAnswerType? = null
      var _failedOptionId: Any? = null
      var _neutralOptionId: Any? = null
      var _answers: InspectionByIdWithMediaUrlQuery.Answers? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _sectionId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _questionText = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _guidelines = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _required = BooleanAdapter.fromJson(reader, customScalarAdapters)
          5 -> _order = IntAdapter.fromJson(reader, customScalarAdapters)
          6 -> _answerType = InspectionAnswerType_ResponseAdapter.fromJson(reader, customScalarAdapters)
          7 -> _failedOptionId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          8 -> _neutralOptionId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          9 -> _answers = Answers.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Question(
        id = _id ?: missingField(reader, "id"),
        sectionId = _sectionId ?: missingField(reader, "sectionId"),
        questionText = _questionText ?: missingField(reader, "questionText"),
        guidelines = _guidelines,
        required = _required ?: missingField(reader, "required"),
        order = _order ?: missingField(reader, "order"),
        answerType = _answerType ?: missingField(reader, "answerType"),
        failedOptionId = _failedOptionId,
        neutralOptionId = _neutralOptionId,
        answers = _answers
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Question,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("sectionId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.sectionId)

      writer.name("questionText")
      StringAdapter.toJson(writer, customScalarAdapters, value.questionText)

      writer.name("guidelines")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.guidelines)

      writer.name("required")
      BooleanAdapter.toJson(writer, customScalarAdapters, value.required)

      writer.name("order")
      IntAdapter.toJson(writer, customScalarAdapters, value.order)

      writer.name("answerType")
      InspectionAnswerType_ResponseAdapter.toJson(writer, customScalarAdapters, value.answerType)

      writer.name("failedOptionId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.failedOptionId)

      writer.name("neutralOptionId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.neutralOptionId)

      writer.name("answers")
      Answers.obj().nullable().toJson(writer, customScalarAdapters, value.answers)
    }
  }

  public object Answers : Adapter<InspectionByIdWithMediaUrlQuery.Answers> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "inspectionId", "questionId", "optionId", "answer", "displayAnswer", "notes", "findingCategory", "media", "lastUpdatedAt")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Answers {
      var _id: Any? = null
      var _inspectionId: Any? = null
      var _questionId: Any? = null
      var _optionId: Any? = null
      var _answer: String? = null
      var _displayAnswer: String? = null
      var _notes: String? = null
      var _findingCategory: FindingCategory? = null
      var _media: List<InspectionByIdWithMediaUrlQuery.Medium>? = null
      var _lastUpdatedAt: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _inspectionId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _questionId = AnyAdapter.fromJson(reader, customScalarAdapters)
          3 -> _optionId = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          4 -> _answer = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          5 -> _displayAnswer = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          6 -> _notes = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          7 -> _findingCategory = FindingCategory_ResponseAdapter.nullable().fromJson(reader, customScalarAdapters)
          8 -> _media = Medium.obj().list().nullable().fromJson(reader, customScalarAdapters)
          9 -> _lastUpdatedAt = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Answers(
        id = _id ?: missingField(reader, "id"),
        inspectionId = _inspectionId ?: missingField(reader, "inspectionId"),
        questionId = _questionId ?: missingField(reader, "questionId"),
        optionId = _optionId,
        answer = _answer,
        displayAnswer = _displayAnswer,
        notes = _notes,
        findingCategory = _findingCategory,
        media = _media,
        lastUpdatedAt = _lastUpdatedAt
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Answers,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("inspectionId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.inspectionId)

      writer.name("questionId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.questionId)

      writer.name("optionId")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.optionId)

      writer.name("answer")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.answer)

      writer.name("displayAnswer")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.displayAnswer)

      writer.name("notes")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.notes)

      writer.name("findingCategory")
      FindingCategory_ResponseAdapter.nullable().toJson(writer, customScalarAdapters, value.findingCategory)

      writer.name("media")
      Medium.obj().list().nullable().toJson(writer, customScalarAdapters, value.media)

      writer.name("lastUpdatedAt")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.lastUpdatedAt)
    }
  }

  public object Medium : Adapter<InspectionByIdWithMediaUrlQuery.Medium> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "fileName", "originalFileName", "size", "fileUploaded", "fileUrl", "thumbnailUrl")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionByIdWithMediaUrlQuery.Medium {
      var _id: Any? = null
      var _fileName: String? = null
      var _originalFileName: String? = null
      var _size: Int? = null
      var _fileUploaded: Boolean? = null
      var _fileUrl: String? = null
      var _thumbnailUrl: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _fileName = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _originalFileName = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _size = IntAdapter.fromJson(reader, customScalarAdapters)
          4 -> _fileUploaded = NullableBooleanAdapter.fromJson(reader, customScalarAdapters)
          5 -> _fileUrl = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          6 -> _thumbnailUrl = NullableStringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionByIdWithMediaUrlQuery.Medium(
        id = _id ?: missingField(reader, "id"),
        fileName = _fileName ?: missingField(reader, "fileName"),
        originalFileName = _originalFileName ?: missingField(reader, "originalFileName"),
        size = _size ?: missingField(reader, "size"),
        fileUploaded = _fileUploaded,
        fileUrl = _fileUrl,
        thumbnailUrl = _thumbnailUrl
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionByIdWithMediaUrlQuery.Medium,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("fileName")
      StringAdapter.toJson(writer, customScalarAdapters, value.fileName)

      writer.name("originalFileName")
      StringAdapter.toJson(writer, customScalarAdapters, value.originalFileName)

      writer.name("size")
      IntAdapter.toJson(writer, customScalarAdapters, value.size)

      writer.name("fileUploaded")
      NullableBooleanAdapter.toJson(writer, customScalarAdapters, value.fileUploaded)

      writer.name("fileUrl")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.fileUrl)

      writer.name("thumbnailUrl")
      NullableStringAdapter.toJson(writer, customScalarAdapters, value.thumbnailUrl)
    }
  }
}
